module.exports = __webpack_public_path__ + "media/images/plus-circle-e5d6ba278b577b4f114e0d339a57e2e1.svg";